export default class TypeStateCCSS {
  id!: number
  status!: string
  isEdit!: boolean
}
